import { connect } from 'react-redux';

import { offerSelector } from '../../../selectors';
import { selectAgent } from '../../../selectors/selectAgent';
import { EFeedbackComplaint, statusChanger } from '../../../store/complaint/feedback_complaint';
import { resetPrefilledEmail } from '../../../store/complaint/prefilledEmail';
import { ComplaintButton, IComplaintButtonProps } from './index';

import type { DispatchReduxAction, IState } from '../../../store';

type TStoreProps = Pick<IComplaintButtonProps, 'agent' | 'offer'>;
type TDispatchProps = Pick<IComplaintButtonProps, 'complaintFeedbackFormStatus' | 'resetPrefilledEmail'>;
type TOwnProps = Omit<IComplaintButtonProps, keyof (TStoreProps & TDispatchProps)>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    agent: selectAgent(state),
    offer: offerSelector(state),
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction): TDispatchProps {
  return {
    complaintFeedbackFormStatus: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
    resetPrefilledEmail: () => dispatch(resetPrefilledEmail()),
  };
}

export const ComplaintButtonContainer = connect<TStoreProps, TDispatchProps, TOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(ComplaintButton);
